<div class="layout-main" id="top">
  <div class="layout-main-top">
    <ng-content select="lui-navbar"></ng-content>
  </div>
  <main class="layout-main-main">
    <ng-content></ng-content>
  </main>
  <div class="layout-main-footer">
    <ng-content select="lui-footer-main"></ng-content>
    <ng-content select="lui-footer-basic"></ng-content>
  </div>
  <div class="layout-main-bottom">
    <div *ngIf="showCookies" class="temp-cookies">Cookies</div>
  </div>
</div>
